import React from 'react';
import { IUserMapFeed } from '@pvplevelup/core/dist/queries/user/user';
import { ProfileMaps } from 'components/Profile/ProfileMaps';

interface Props {
  mapFeed: IUserMapFeed | undefined;
  fetchMoreRecords: ()=>void;
}

/** The user page's Maps tab. */
const UserMaps: React.FC<Props> = ({mapFeed,fetchMoreRecords}) => {
  return <ProfileMaps mapFeed={mapFeed} fetchMoreRecords={fetchMoreRecords} />;
};

export {UserMaps};
